import React from "react";
import "../styles.css";
import "bootstrap/dist/css/bootstrap.min.css";

function Card(props) {
  return (
    <div className="card" style={{ width: "15rem" }}>
      {/* <img src={props.imgSrc} className="card-img-top" alt="..." /> */}
      <div>{props.imgSrc}</div>
      <div className="card-body" />
      <h5 className="card-title">{props.title}</h5>
      <p className="card-text">{props.description}</p>
      <a href={props.link} className="btn btn-primary">
        Check Price
      </a>
    </div>
  );
}

export default Card;
